import { doc, setDoc } from 'firebase/firestore';
import { ITestsSetting } from '../../providers/settings/testsSettingProvider';
import { userAsPromise } from '../../providers/userProvider';

/**
 * @description persists the users setting for tests
 * @param settings
 */
export const saveTestsSetting = async (
  settings: ITestsSetting
): Promise<void> => {
  const user = await userAsPromise();

  return setDoc(
    doc(user.services.firestore, `userProfiles/${user.id}/settings/tests`),
    settings,
    { merge: true }
  );
};
